import { Grid, Header } from "semantic-ui-react";

import { Outlet } from "react-router-dom";

export default function Login() {
	return (
		<div className="login-form">
			<Grid textAlign="center">
				<Grid.Column textAlign="left" style={{ marginTop: "3%", maxWidth: 550 }}>
					<Header as="h1" style={{ fontSize: "4vw", letterSpacing: "-.05em" }} textAlign="center">
						<a href="https://astrid.fm" className="login-logo">
							<img src="/img/astrid-logo.svg" alt="Astrid" />
						</a>
					</Header>
					<Outlet />
				</Grid.Column>
			</Grid>
		</div>
	);
}
